export default __webpack_public_path__ + "static/media/P314.2.0afac8b9.mp3";